import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Dropdown/Dropdown.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { Popover } from "@headlessui/react";
import { Fragment, jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var Dropdown = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(Popover, __spreadProps(__spreadValues({
    ref,
    as: Component
  }, rest), {
    className: clsx("pd:dropdown", className),
    children: _ref => {
      let {
        open
      } = _ref;
      return (
        // 'useless' Fragment is by design. ESLint is dumb.
        // eslint-disable-next-line react/jsx-no-useless-fragment
        /* @__PURE__ */
        jsx(Fragment, {
          children: typeof children === "function" ? children({
            open
          }) : children
        })
      );
    }
  }));
});
var StoryDropdown = args => /* @__PURE__ */jsx(Dropdown, __spreadValues({}, args));
var Dropdown_default = Dropdown;
export { StoryDropdown, Dropdown_default };